var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getFocusables } from '../lib-getFocusables';
import { clamp } from '../lib-codash';
import { polyfillCustomEvent } from '../lib-polyfills';
/**
 * Apply keydownToArrow and menuFocus on a menu where you want to move focus
 * with arrows and Home and End
 * Provide a selector that can get all the focusables
 *
 * If you want to have another behavior for a specific item
 * i.e. if Left arrow on a menu item should open its submenu
 * then add keydown listener on the item and stop event propagation
 *
 * Returns function to remove listeners
 *
 * Up and Left moves focus to the previous item in the menu
 * Down and Right moves focus to the next item in the menu
 * Arrow keys don't move focus outside of the current menu
 * Focus doesn't cycle, Up on the first item will not move focus
 * Home and End move focus to the first and last item of the current menu
 *
 * Set cycle to true if the focus should cycle
 */
export function menuFocus(menu, focusablesSelector, cycle) {
    if (cycle === void 0) { cycle = false; }
    polyfillCustomEvent();
    menu.addEventListener('arrow', arrow);
    return function () { return menu.removeEventListener('arrow', arrow); };
    function arrow(e) {
        e.stopPropagation();
        var items = getFocusables(menu, focusablesSelector);
        var target = e.target;
        var currentIndex = items.indexOf(target);
        var unboundIndex = keyToIndex(e.detail, currentIndex, items.length);
        var boundIndex = cycle
            ? (unboundIndex + items.length) % items.length
            : clamp(unboundIndex, 0, items.length - 1);
        items[boundIndex].focus();
    }
}
/**
 * Convert keydown events to arrow events
 * Apply on the top-level menu
 */
export var HOME_END_KEYS = ['Home', 'End'];
export var UP_KEYS = ['Up', 'ArrowUp'];
export var DOWN_KEYS = ['Down', 'ArrowDown'];
export var UP_DOWN_KEYS = __spreadArray(__spreadArray([], UP_KEYS, true), DOWN_KEYS, true);
export var LEFT_KEYS = ['Left', 'ArrowLeft'];
export var RIGHT_KEYS = ['Right', 'ArrowRight'];
export var LEFT_RIGHT_KEYS = __spreadArray(__spreadArray([], LEFT_KEYS, true), RIGHT_KEYS, true);
export var ARROW_KEYS = __spreadArray(__spreadArray([], UP_DOWN_KEYS, true), LEFT_RIGHT_KEYS, true);
export var ALL_KEYS = __spreadArray(__spreadArray(__spreadArray([], UP_DOWN_KEYS, true), LEFT_RIGHT_KEYS, true), HOME_END_KEYS, true);
export function keydownToArrow(e, arrowKeys) {
    if (arrowKeys === void 0) { arrowKeys = ALL_KEYS; }
    if (arrowKeys.includes(e.key)) {
        var event_1 = new CustomEvent('arrow', { detail: e.key, cancelable: true, bubbles: true });
        e.target.dispatchEvent(event_1);
        e.preventDefault(); // do not scroll the page
    }
}
export function keyToIndex(key, currentIndex, length) {
    switch (key) {
        case 'Up':
        case 'ArrowUp':
        case 'Left':
        case 'ArrowLeft':
            return currentIndex - 1;
        case 'Down':
        case 'ArrowDown':
        case 'Right':
        case 'ArrowRight':
            return currentIndex + 1;
        case 'Home':
            return 0;
        case 'End':
            return length;
        default:
            return currentIndex;
    }
}
